/*
 * Copyright (c) 2022 - present, Orangecells Innovation Lab Private Limited [https://orangecells.com]
 *
 * All rights reserved.
 */

import React, { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { animateScroll } from "react-scroll";
import ContactUs from "../Components/ContactUs";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const Layout = ({ children }) => {
  const path = useLocation();

  useEffect(() => {
    if (path.hash) {
      const targetElement = document.querySelector(path.hash);

      if (targetElement) {
        var scrollValue = targetElement.offsetTop;

        animateScroll.scrollTo(scrollValue);
      }
    } else {
      animateScroll.scrollTo(0);
    }
  }, [path]);

  return (
    <Fragment>
      <Header />
      <div className="w-full h-full">{children}</div>
      <ContactUs />
      <Footer />
    </Fragment>
  );
};

export default Layout;
